/* eslint-disable */

import React from "react";
import gettext from "../../shared/utils/gettext";
import LinkPartner from "./LinkedPartner";

class LinkAVR extends React.Component {
  render() {
    return (
      <LinkPartner
        gid="avrbe"
        name="AVR"
        logo_url="/static/img/avr.webp"
        logo_height="50"
        description={
          <>
            {gettext(
              "Cloudfarm offers integration with AVR Connect. Through this system, the yield data will become automatically available in Cloudfarm and the harvest operation will be automatically recorded in Dacom."
            )}
            <p className="mt-1">
              {gettext("To configure the connection or get more information, please visit")}&nbsp;
              <a href="http://www.avr.be/" target="_blank">
                {gettext("the AVR website")}
              </a>
              &nbsp;
              {gettext("and take a look at ")}
              <a href="/static/cloudfarm/doc/Connectie Dacom - AVR Connect NL .pdf" target="_blank">
                &nbsp;
                {gettext("this manual")}.
              </a>
            </p>
          </>
        }
      />
    );
  }
}

export default LinkAVR;
